// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notify-modal .ant-modal-body {
  padding: 1rem !important;
}

.notify-modal-space {
  width: 100%;
  margin-top: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/modal/notify-model/NotifyModel.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".notify-modal .ant-modal-body {\n  padding: 1rem !important;\n}\n\n.notify-modal-space {\n  width: 100%;\n  margin-top: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
